/**
 * Clients — canonical CRM client directory (flowstate-automate parity).
 *
 * Renders ClientsPanel (table/grid, export, health, opportunities tabs).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import ClientsPanel from "@/components/admin/clients/ClientsPanel";
import { OnDemandServiceLoader } from "@/components/system/OnDemandServiceLoader";

export const Route = createFileRoute("/_admin/clients/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  pendingComponent: () => <PageSkeleton rows={8} variant="list" />,
  errorComponent: createRouteError("Clients"),
  component: ClientsPage,
});

function ClientsPage() {
  return (
    <OnDemandServiceLoader serviceNames={["client", "opportunity"]}>
      <div className="flex min-h-0 flex-1 flex-col">
        <ClientsPanel />
      </div>
    </OnDemandServiceLoader>
  );
}
